import { ReactElement } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'
import { useFlags } from '@equipmentshare/feature-flags'
import FulfillmentOrders from './FulfillmentOrders'
import FulfillmentOrderDetails from './FulfillmentOrderDetails'
import MttManagement from './MttManagement'
import MttDetails from './MttDetails'
import PickOrders from './pick-orders/PickOrders'
import PickOrderDetails from './pick-orders/PickOrderDetails'

export default function DcAdminRoutes(): ReactElement {
	const flags = useFlags()
	const pickOrdersEnabled = Boolean( flags.costentoryEnablePickOrders )

	return (
		<Routes>
			<Route index element={<Navigate to="fulfillment-orders" replace />} />
			<Route path="fulfillment-orders" element={<FulfillmentOrders />} />
			<Route path="fulfillment-orders/:orderNumber" element={<FulfillmentOrderDetails />} />
			<Route path="mtt" element={<MttManagement />} />
			<Route path="mtt/:branchId" element={<MttDetails />} />
			<Route
				path="pick-orders"
				element={pickOrdersEnabled ? <PickOrders /> : <Navigate to="/dc-admin/fulfillment-orders" replace />}
			/>
			<Route
				path="pick-orders/:id"
				element={pickOrdersEnabled ? <PickOrderDetails /> : <Navigate to="/dc-admin/fulfillment-orders" replace />}
			/>
		</Routes>
	)
}
